module.exports = __webpack_public_path__ + "static/media/logo.4c6b221c.png";